import { gql } from "@apollo/client";

export const validateHopMiraklSsoQuery = gql`
    query ValidateHopMiraklSso($state: String!, $code: String!) {
      validateHopMiraklSso(state: $state, code: $code){
          redirectUrl
        }
    }
`;
